import { axiosRestInstance } from "../axios";
import {
  DeleteMediaFileResponse,
  GetMediaFilesResponse,
  UploadMediaFilesResponse,
} from "../../redux/slices/project-validation/Types";

/** Media module names used by the global media APIs. */
export type MediaType = "integration" | "benefit_log" | "service" | string;

export type UploadMediaParams = {
  type: MediaType;
  typeId: string | number;
  files: File[];
  uploadedBy: number;
  /** Optional YYYY-MM-DD override for created_at. */
  createdAt?: string;
};

/**
 * GET /getMedia/:type/:typeId
 * Fetch media files for a module record.
 */
export const getMediaAPI = async (
  type: MediaType,
  typeId: string | number
): Promise<GetMediaFilesResponse> => {
  const response = await axiosRestInstance.get<GetMediaFilesResponse>(
    `/getMedia/${type}/${typeId}`
  );
  return response.data;
};

/**
 * POST /uploadMedia/
 * Upload media files. type and type_id go in the form body (not the URL).
 */
export const uploadMediaAPI = async ({
  type,
  typeId,
  files,
  uploadedBy,
  createdAt,
}: UploadMediaParams): Promise<UploadMediaFilesResponse> => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("file_path", file);
  });

  formData.append("uploaded_by", uploadedBy.toString());
  formData.append("type", type);
  formData.append("type_id", String(typeId));

  if (createdAt) {
    formData.append("created_at", createdAt);
  }

  const response = await axiosRestInstance.post<UploadMediaFilesResponse>(
    `/uploadMedia/`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

/**
 * DELETE /deleteMedia/:mediaId
 * Delete a single media file by its media row id.
 */
export const deleteMediaAPI = async (
  mediaId: number
): Promise<DeleteMediaFileResponse> => {
  const response = await axiosRestInstance.delete<DeleteMediaFileResponse>(
    `/deleteMedia/${mediaId}`
  );
  return response.data;
};
